export default {
  productTradeMark: {
    TrademarkCode: 'Trademark Code',
    TrademarkName: 'Trademark Name',
    AddTrademark: 'Add Trademark',
    EditTrademark: 'Edit Trademark',
    PleaseEnterTrademarkName: 'Please Enter Trademark Name',
    PleaseEnterTrademarkCode: 'Please Enter Trademark Code',
    PleaseEnterCorrectTrademarkCode: 'Please Enter Correct Trademark Code',
    PleaseEnterCorrectTrademarkName: 'Please Enter Correct Trademark Name'
  }
}



// WEBPACK FOOTER //
// ./src/i18n/lang/en/pmc/productTradeMark.js